/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './component';
import './device_event';
import './device_diagnostics';
import './software_update_details';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "Device": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "attributes": {
                    "type": "squareup.connect.v2.DeviceAttributes",
                    "id": 2,
                    "rule": "optional"
                  },
                  "components": {
                    "type": "squareup.connect.v2.Component",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "status": {
                    "type": "squareup.connect.v2.DeviceStatus",
                    "id": 4,
                    "rule": "optional"
                  },
                  "parentDeviceIds": {
                    "type": "string",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "childDeviceIds": {
                    "type": "string",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "aggregatedStatus": {
                    "type": "squareup.connect.v2.DeviceStatus",
                    "id": 8,
                    "rule": "optional"
                  },
                  "events": {
                    "type": "squareup.connect.v2.DeviceEvent",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "diagnostics": {
                    "type": "squareup.connect.v2.DeviceDiagnostics",
                    "id": 10,
                    "rule": "optional"
                  },
                  "softwareUpdateDetails": {
                    "type": "squareup.connect.v2.SoftwareUpdateDetails",
                    "id": 11,
                    "rule": "optional"
                  },
                  "aggregatedPeripheralStatus": {
                    "type": "squareup.connect.v2.DeviceStatus",
                    "id": 12,
                    "rule": "optional"
                  }
                }
              },
              "DeviceAttributes": {
                "fields": {
                  "type": {
                    "type": "squareup.connect.v2.DeviceAttributes.DeviceType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "manufacturer": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "model": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "manufacturersId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "lastUsedAt": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "installationId": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "peripheralId": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "squareHardwareType": {
                    "type": "squareup.connect.v2.DeviceAttributes.SquareHardwareType",
                    "id": 13,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DeviceType": {
                    "values": {
                      "DEVICE_TYPE_INVALID_TYPE": 0,
                      "TERMINAL": 1,
                      "REGISTER": 2,
                      "IOS": 3,
                      "ANDROID": 4,
                      "CASH_DRAWER": 5,
                      "PRINTER": 6,
                      "READER": 7,
                      "SCALE": 8,
                      "BARCODE_SCANNER": 9,
                      "STAND": 10,
                      "INTERNAL_PRINTER": 11,
                      "SCANNER_SCALE": 12,
                      "INTERNAL_SCANNER": 13
                    }
                  },
                  "SquareHardwareType": {
                    "values": {
                      "SQUARE_HARDWARE_TYPE_INVALID_TYPE": 0,
                      "SQUARE_HARDWARE_TYPE_TERMINAL_GEN1_V1": 1,
                      "SQUARE_HARDWARE_TYPE_TERMINAL_GEN1_V2": 2,
                      "SQUARE_HARDWARE_TYPE_TERMINAL_GEN2_V1": 3,
                      "SQUARE_HARDWARE_TYPE_REGISTER_GEN1_V1": 4,
                      "SQUARE_HARDWARE_TYPE_REGISTER_GEN1_V2": 5,
                      "SQUARE_HARDWARE_TYPE_STAND_GEN1_V1": 6,
                      "SQUARE_HARDWARE_TYPE_STAND_GEN1_V2": 7,
                      "SQUARE_HARDWARE_TYPE_STAND_GEN1_V3": 8,
                      "SQUARE_HARDWARE_TYPE_STAND_GEN1_V4": 9,
                      "SQUARE_HARDWARE_TYPE_STAND_GEN1_V5": 10,
                      "SQUARE_HARDWARE_TYPE_STAND_GEN2_V1": 11,
                      "SQUARE_HARDWARE_TYPE_STAND_GEN2_V2": 12
                    }
                  }
                }
              },
              "DeviceStatus": {
                "fields": {
                  "category": {
                    "type": "squareup.connect.v2.DeviceStatus.Category",
                    "id": 1,
                    "rule": "optional"
                  },
                  "detail": {
                    "type": "squareup.connect.v2.DeviceStatus.Detail",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Category": {
                    "values": {
                      "DEVICE_STATUS_INVALID_TYPE": 0,
                      "AVAILABLE": 1,
                      "NEEDS_ATTENTION": 2,
                      "CRITICAL": 3,
                      "OFFLINE": 4
                    }
                  },
                  "Detail": {
                    "values": {
                      "DEVICE_STATUS_DETAIL_INVALID_TYPE": 0,
                      "SLEEPING": 1,
                      "LOGGED_OUT": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.Device && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceAttributes && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceAttributes?.nested?.DeviceType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceAttributes?.nested?.SquareHardwareType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceStatus && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceStatus?.nested?.Category && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceStatus?.nested?.Detail) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Device @ squareup/devices/external/device.proto at 17:1
 */
export const Device = $root.lookupType('squareup.connect.v2.Device');
fixType(Device, {
  attributes: {
    required: true
  }
});
Builder.createAndAttachToType(Device);
/**
 * SOURCE DeviceAttributes @ squareup/devices/external/device.proto at 110:1
 */
export const DeviceAttributes = $root.lookupType('squareup.connect.v2.DeviceAttributes');
fixType(DeviceAttributes, {
  type: {
    required: true
  },
  manufacturer: {
    required: true
  }
});
Builder.createAndAttachToType(DeviceAttributes);
/**
 * --
 * @desc An enum identifier of the device type.
 * --
 *
 * SOURCE DeviceType @ squareup/devices/external/device.proto at 116:3
 */
DeviceAttributes.DeviceType = $root.lookupEnum('squareup.connect.v2.DeviceAttributes.DeviceType').values;
/**
 * --
 * @desc An enum identifier of the Square Hardware Type. Set only for Square Hardware devices.
 * --
 *
 * SOURCE SquareHardwareType @ squareup/devices/external/device.proto at 235:3
 */
DeviceAttributes.SquareHardwareType = $root.lookupEnum('squareup.connect.v2.DeviceAttributes.SquareHardwareType').values;
/**
 * SOURCE DeviceStatus @ squareup/devices/external/device.proto at 287:1
 */
export const DeviceStatus = $root.lookupType('squareup.connect.v2.DeviceStatus');
fixType(DeviceStatus);
Builder.createAndAttachToType(DeviceStatus);
/**
 * SOURCE Category @ squareup/devices/external/device.proto at 290:3
 */
DeviceStatus.Category = $root.lookupEnum('squareup.connect.v2.DeviceStatus.Category').values;
/**
 * SOURCE Detail @ squareup/devices/external/device.proto at 310:3
 */
DeviceStatus.Detail = $root.lookupEnum('squareup.connect.v2.DeviceStatus.Detail').values;